import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
    name: 'sanitize',
    standalone: false
})
export class SanitizePipe implements PipeTransform {
  constructor(private sanitize: DomSanitizer) {}

  transform(
    value: string,
    bypass: 'trustUrl' | 'trustResourceUrl' = 'trustUrl'
  ): SafeUrl | undefined {
    if (!value) return undefined;
    if (bypass === 'trustUrl')
      return this.sanitize.bypassSecurityTrustUrl(value);
    else return this.sanitize.bypassSecurityTrustResourceUrl(value);
  }
}
